import { render, staticRenderFns } from "./ImportDownload.vue?vue&type=template&id=aef4fa80&scoped=true"
import script from "./ImportDownload.vue?vue&type=script&lang=js"
export * from "./ImportDownload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aef4fa80",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aef4fa80')) {
      api.createRecord('aef4fa80', component.options)
    } else {
      api.reload('aef4fa80', component.options)
    }
    module.hot.accept("./ImportDownload.vue?vue&type=template&id=aef4fa80&scoped=true", function () {
      api.rerender('aef4fa80', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/finance/basicData/cope/dispatchReferenceTable/cmp/ImportDownload.vue"
export default component.exports